export default "__VITE_ASSET__Q$iwYTLX__"